<template>
    <!--begin::Root-->
    <div class="d-flex flex-column flex-root">
        <!--begin::Page-->
        <div class="page d-flex flex-row flex-column-fluid">
            <Aside />
            <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                <!--begin::Header-->
                <Header />
                <!--end::Header-->
                <!--begin::Content-->
                <Content>
                    <slot></slot>
                </Content>
                <!--end::Content-->
                <!--begin::Footer-->
                <Footer />
                <!--end::Footer-->
            </div>
        </div>
        <!--end::Page-->
    </div>

    <simple-modal ref="modal"/>

  <!-- end:root -->
</template>

<script>
import Aside from "../Components/Structure/Aside";
import Header from "../Components/Structure/Header";
import Content from "../Components/Structure/Content";
import Footer from "../Components/Structure/Footer";
import {info, success, warning, error} from "@settings/toastr";
import SimpleModal from "../Components/Structure/Modal";

export default {
    components: {
      Footer,
      Content,
      Aside,
      Header,
      SimpleModal
    },
    mounted() {
        KTApp.init();
        KTMenu.createInstances();
        KTDrawer.createInstances();
        KTScroll.createInstances();
        KTScrolltop.createInstances();
        KTSticky.createInstances();
        KTDialer.createInstances();
        KTImageInput.createInstances();
        KTPasswordMeter.createInstances();
        KTSwapper.createInstances();
        KTToggle.createInstances();

      if (this.$page.props.success) {
        success(this.$page.props.success)
      }

      if (this.$page.props.info) {
        info(this.$page.props.info)
      }

      if (this.$page.props.error) {
        error(this.$page.props.error)
      }

      if (this.$page.props.warning) {
        warning(this.$page.props.warning)
      }

      // SweetAlert
      this.emitter.on('alert', config => {
        Swal.fire({
          title: config.title || '',
          html: config.text || 'Essa ação é irreversível. Deseja continuar?',
          icon: config.icon || 'warning',
          showCancelButton: config.showCancelButton !== false,
          showConfirmButton: config.showConfirmButton !== false,
          confirmButtonText: config.confirmButtonText || 'Sim, continuar',
          cancelButtonText: config.cancelButtonText || 'Cancelar',
          reverseButtons: config.reverseButtons || false,
          buttonsStyling: false,
          customClass: {
            confirmButton: 'swal2-confirm btn btn-primary',
            cancelButton: 'swal2-cancel btn btn-active-light',
            ...config.customClass,
          }
        }).then(result => {
          if(result.value) {
            config.success();
          }
        });
      });

      this.emitter.on('modal', config => {
        this.$nextTick(() => {
          this.$refs.modal.open(config);
        })
      });
    }
}
</script>
